<div class="d-flex flex-row" [ngClass]="collapsed ? 'sidebar-closed' : 'sidebar-open'" *ngrxLet="collapsed$ as collapsed">
    <app-sidebar *ngIf="user$ | async as user"></app-sidebar>
    <div class="d-flex flex-column content-wrapper">
        <div>
            <app-navbar *ngIf="user$ | async as user"></app-navbar>
        </div>
        <div>
            <router-outlet></router-outlet>
        </div>
    </div>
</div>

<p-toast></p-toast>
